import { useEffect, useState } from 'react';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import Typography from 'components/global/Typography';

import * as S from './Common.styled';

const AppIntegrationFrame = () => {
	const [loading, setLoading] = useState(true);

	const onSubmit = (e) => {
		e.preventDefault();
		setLoading(true);
		const url = new URL(window.location.href);
		if (url?.search) {
			// const salesChannelUrl = `sales-channels/bigcommerce-form?account_uuid=${accountUuid}&code=${code}&context=${context}&scope=${scope}`;
			window.open(`${url.origin}/sales-channels/bigcommerce-form${url.search}`, '_blank');
		}
		setLoading(false);
	};

	useEffect(() => {
		setLoading(false);
	}, []);

	return (
		<>
			<S.FormContainer onSubmit={(e) => onSubmit(e)}>
				<Typography variant="h2" fontWeight="500" gutterBottom>
					letsGetStarted
				</Typography>
				<Typography variant="p1" gutterBottom noWrap>
					integration.leadText
				</Typography>
				<Button size="large" loading={loading} onClick={(e) => onSubmit(e)}>
					<Typography className="button-text" fontWeight="500">
						connect
					</Typography>
				</Button>
			</S.FormContainer>

			{loading && <Loading />}
		</>
	);
};

export default AppIntegrationFrame;
